import React from 'react';
import ContentCourseFailureAttemptRateSummary from './ContentCourseFailureAttemptRateSummary';
import { ContentCourseFailureAttemptRateListService } from '../../services/ContentListService';
import { observer } from 'mobx-react';

const ContentCourseFailureAttemptRateSummaryContainer = () => {
  const summary = ContentCourseFailureAttemptRateListService.getChart();
  return (
    <ContentCourseFailureAttemptRateSummary
      isLoading={
        ContentCourseFailureAttemptRateListService.fetchCurrent.fetching ||
        ContentCourseFailureAttemptRateListService.fetchPrevious.fetching
      }
      previousValue={summary.previous}
      currentValue={summary.current}
      formatter={ContentCourseFailureAttemptRateListService.getFormattedValue}
    />
  );
};

export default observer(ContentCourseFailureAttemptRateSummaryContainer);
